const styles = {
  dialogPaper: {
    padding: '24px',
    width: 900,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    color: 'text.secondary',
  },
  dialogTitle: {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '20px',
    padding: '0 0 8px',
  },
  dialogContent: {
    padding: 0,
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 0 0',
  },
  spacer: {
    flex: 1,
  },
};

export default styles;
